import { get, post, del } from './client.js';

/** 複製到剪貼簿 — HTTPS 用 navigator.clipboard；HTTP（staging）退回 execCommand */
export function copyToClipboard(val) {
    try {
        if (navigator.clipboard && window.isSecureContext) { navigator.clipboard.writeText(val).catch(() => execCopy(val)); return; }
    } catch (_) { /* fall through */ }
    execCopy(val);
}
function execCopy(val) {
    try {
        const ta = document.createElement('textarea');
        ta.value = val; ta.style.position = 'fixed'; ta.style.top = '0'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.focus(); ta.select();
        document.execCommand('copy'); document.body.removeChild(ta);
    } catch (_) { /* ignore */ }
}

/** 讀綁定狀態（憑證遮罩） */
export const getLineBinding = (avatarId) =>
    get(`/api/line/binding?avatarId=${encodeURIComponent(avatarId)}`);

/** 綁定：存憑證 → 自動掛 webhook → 測試 */
export const bindLine = (payload) => post('/api/line/bind', payload);

/** 產生 文字/語音 LIFF（kind:'text'|'voice', viewType:'compact'|'tall'|'full'） */
export const generateLiff = (payload) => post('/api/line/liff/generate', payload);

/** 解除綁定 */
export const unbindLine = (avatarId) =>
    del(`/api/line/bind?avatarId=${encodeURIComponent(avatarId)}`);

/** 讀既有 rich menu 狀況（是否本系統建 + 縮圖） */
export const getRichMenuStatus = (avatarId) =>
    get(`/api/line/richmenu/status?avatarId=${encodeURIComponent(avatarId)}`);

/** 用 Nano Banana 2 生選單底圖（{ avatarId, size, prompt } → { imageBase64 }） */
export const generateMenuBg = (payload) => post('/api/line/richmenu/generate-bg', payload);

/** 掛載 rich menu（傳 PNG base64 + areas + size + buttons config） */
export const mountRichMenu = (payload) => post('/api/line/richmenu/mount', payload);

/** 刪除 rich menu */
export const deleteRichMenu = (avatarId) =>
    del(`/api/line/richmenu?avatarId=${encodeURIComponent(avatarId)}`);
